module.exports = __webpack_public_path__ + "static/how-to-lie-with-statistics-01499c0ca8cd94ad58dba21005ac14bb.jpg";